import {
  FAIL_FETCH_STATS_SALES,
  REQUEST_FETCH_STATS_SALES,
  SUCCESS_FETCH_STATS_SALES,
} from '../../../actions/entities/statistics/sales';
import {createReducer} from '../../utilities';

const initialState = {
  data: null,
  error: false,
  isFetching: false,
};

function requestFetch(state) {
  return {
    ...state,
    isFetching: true,
  };
}

function successFetch(state, action) {
  const {data} = action;
  return {
    ...state,
    data: {...data.countries, purchases: data.purchases},
    isFetching: false,
  };
}

function failFetch(state, action) {
  const {error} = action;
  return {
    ...state,
    isFetching: false,
    error,
  };
}

export default createReducer(initialState, {
  [REQUEST_FETCH_STATS_SALES]: requestFetch,
  [SUCCESS_FETCH_STATS_SALES]: successFetch,
  [FAIL_FETCH_STATS_SALES]: failFetch,
});



// WEBPACK FOOTER //
// ./src/reducers/app/statistics/sales.js